var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('AsideLogo',{attrs:{"mini-variant":_vm.miniVariant}}),_c('Items',{attrs:{"mini-variant":_vm.miniVariant}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }